import {
  onChangeText,
  restoreText,
  setText,
} from "@-/dev.improve.haniverse.modules.persistent-keyboard";
import { useEffect, useRef, useState } from "react";

/** One native text/count pair belongs to the retained review, rather than its mounted field. */
export function useDrillKeyboardText(
  isActive: boolean,
): readonly [string, typeof setText, number, string?] {
  const [state, setState] = useState({
    mostRecentEventCount: 0,
    sourceValue: undefined as string | undefined,
    text: "",
  });
  const latest = useRef(state);
  useEffect(() => {
    if (!isActive) {
      return;
    }
    const subscription = onChangeText((event) => {
      const previous = latest.current;
      const mostRecentEventCount = event.eventCount ?? previous.mostRecentEventCount;
      if (mostRecentEventCount < previous.mostRecentEventCount) {
        return;
      }
      if (
        mostRecentEventCount === previous.mostRecentEventCount &&
        event.text === previous.text &&
        event.sourceValue === previous.sourceValue
      ) {
        return;
      }
      latest.current = { mostRecentEventCount, sourceValue: event.sourceValue, text: event.text };
      setState(latest.current);
    });
    // Another screen may have used the module while this review was hidden. Restore only on
    // activation, through the native owner. Reuse the revision only when both native text and
    // revision are unchanged; otherwise restore with a fresh count. Never request focus.
    restoreText(
      latest.current.text,
      latest.current.mostRecentEventCount,
      latest.current.sourceValue,
    );
    return () => subscription.remove();
  }, [isActive]);
  return [state.text, setText, state.mostRecentEventCount, state.sourceValue] as const;
}
